import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth, formatApiErrorDetail } from '../contexts/AuthContext';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2, ArrowLeft } from 'lucide-react';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center" data-testid="login-page">
      <div className="w-full max-w-md mx-4">
        <div className="border border-gray-200 bg-white p-8">
          <div className="flex items-center gap-3 mb-8">
            <div className="swiss-cross" />
            <span className="font-['Chivo'] font-black text-xl text-[#111827] tracking-tight">Déclaration d'impôts</span>
          </div>
          <h1 className="font-['Chivo'] font-black text-2xl text-[#111827] mb-1">Espace fiduciaire</h1>
          <p className="text-sm text-gray-500 font-['IBM_Plex_Sans'] mb-8">Connectez-vous pour accéder à votre tableau de bord</p>

          <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
            <div>
              <Label className="block text-sm font-bold text-gray-900 mb-2">Email</Label>
              <Input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="votre@email.ch"
                className="bg-white border border-gray-300 rounded-none px-4 py-3 focus:border-[#E3000F] focus:ring-1 focus:ring-[#E3000F] text-base w-full"
                required
              />
            </div>
            <div>
              <Label className="block text-sm font-bold text-gray-900 mb-2">Mot de passe</Label>
              <Input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Votre mot de passe"
                className="bg-white border border-gray-300 rounded-none px-4 py-3 focus:border-[#E3000F] focus:ring-1 focus:ring-[#E3000F] text-base w-full"
                required
              />
            </div>
            {error && <p className="text-[#E3000F] text-sm font-semibold" data-testid="login-error">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#E3000F] text-white hover:bg-[#A6000B] px-8 py-4 font-bold text-base tracking-wide transition-colors font-['IBM_Plex_Sans'] flex items-center justify-center gap-2 disabled:opacity-50"
              data-testid="login-submit-button"
            >
              {loading ? <Loader2 className="animate-spin" size={18} /> : null}
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <Link to="/" className="text-sm text-gray-500 hover:text-[#E3000F] transition-colors font-['IBM_Plex_Sans'] inline-flex items-center gap-1" data-testid="back-to-home">
              <ArrowLeft size={14} />
              Retour au site
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
